// VOIP2 is not VAT registered yet, so prices are final. Set VAT_PERCENT in Coolify (and rebuild) once registered.
export const VAT_PERCENT = Number(process.env.REACT_APP_VAT_PERCENT || 0);
export const vatNote = (short = false) => {
  if (VAT_PERCENT > 0) return short ? 'excl. VAT' : 'excluding VAT';
  return 'no VAT added';
};
/** For portal screens, which get the rate from the API. */
export const vatSuffix = (percent) => (percent > 0 ? ` incl. ${percent}% VAT` : '');
